import { render, staticRenderFns } from "./PanoramaScene.vue?vue&type=template&id=83b3f268&"
import script from "./PanoramaScene.vue?vue&type=script&lang=js&"
export * from "./PanoramaScene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports